import React from 'react';
import './styles.css';
import {
    cloud, 
    info, 
    seguridad, 
    usuario
} from './ERP/imagenesERP'

export default function DescripcionERP(props){


    return(<>
     <div className='contenedorDescripcionCFDI'>
        <div className='contenedorGeneralDescripcionCFDI'>
        <div className='contenedorTituloDescripcionCFDI'>
            <p>¿POR QUÉ ADQUIRIR T&T ERP?</p>
        </div>
        <div className='caracteristicasDescripcionCFDI'>
            <div className='contenedorConjunto'>
                <div className='contenedorImagenDescripcionCFDI'>
                    <img src={usuario}/>
                </div>
                <div className='contenedorDescripcionCFDIImagen'>
                    <p>Sistema <br/> Multiusuario</p>
                </div>
            </div>

            <div className='contenedorConjunto'>
                <div className='contenedorImagenDescripcionCFDI'>
                    <img src={cloud}/>
                </div>
                <div className='contenedorDescripcionCFDIImagen'>
                    <p>Información<br/> en línea</p>
                </div>
            </div>

            <div className='contenedorConjunto'>
                <div className='contenedorImagenDescripcionCFDI'>
                    <img src={seguridad}/>
                </div>
                <div className='contenedorDescripcionCFDIImagen'>
                    <p>Seguridad por <br/> usuario y función</p>
                </div>
            </div>

            <div className='contenedorConjunto'>
                <div className='contenedorImagenDescripcionCFDI'>
                    <img src={info}/>
                </div>
                <div className='contenedorDescripcionCFDIImagen'>
                    <p>Procesos de  <br/> información adecuados</p>
                </div>
            </div>
        </div>
    </div>
</div>
    </>)
}